import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Observable, of } from "rxjs";
import { ReportsService } from "../reports.service";

@Component({
	selector: "tg-reports-toolbar-actions",
	templateUrl: "./reports-toolbar-actions.component.html",
})
export class ReportsToolbarActionsComponent {
	constructor(public reports: ReportsService) {}

	@Input() showBack = false;
	@Input() showSave = false;
	@Input() showRounding = false;
	@Input() showExport = false;
	@Input() exportDisabled$: Observable<boolean> = of(false);
	@Input() theme$: Observable<string> = of("light");
	@Input() timeLoading$: Observable<boolean> = of(false);

	@Output() goBack = new EventEmitter<void>();
	@Output() saveDashboard = new EventEmitter<void>();
	@Output() openRounding = new EventEmitter<void>();
	@Output() share = new EventEmitter<void>();
	@Output() openExport = new EventEmitter<void>();

	readonly roundingData$ = this.reports.roundingData$;
}
